import React from 'react';
import { ICON_TYPES } from '../constants';
import { IconPropsType } from '../IconProps.type';

export const PDFIcon = (props: IconPropsType): JSX.Element => {
  const svgProps = {
    fill: props.fill || '#E35205',
    width: props.width || '18',
    height: props.height || '20',
  };
  return (
    <svg {...svgProps} viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0084 0H3.16669C1.79169 0 0.666687 1.125 0.666687 2.5V20H17.3334V6.325L11.0084 0ZM11.5 2.84167L14.4917 5.83333H11.5V2.84167ZM15.6667 18.3333H2.33335V2.5C2.33335 2.04167 2.70835 1.66667 3.16669 1.66667H9.83335V7.5H15.6667V18.3333ZM4.80835 10.8333H3.16669V15.8917H4.20835V14.1417H4.80835C5.73335 14.1417 6.48335 13.4 6.48335 12.4833C6.48335 11.5667 5.73335 10.8333 4.80835 10.8333ZM4.80835 13.1H4.21669V11.875H4.80835C5.15002 11.875 5.44169 12.1583 5.44169 12.4833C5.44169 12.8083 5.15002 13.0917 4.80835 13.0917V13.1ZM9.00002 10.8917C8.77502 10.8917 8.56669 10.8917 8.37502 10.8917H7.33335V15.8917H8.37502C8.56669 15.8917 8.77502 15.8917 9.00002 15.8917C9.92502 15.8917 10.6667 15.15 10.6667 14.2417V12.55C10.6667 11.6417 9.92502 10.9 9.00002 10.9V10.8917ZM9.62502 12.5583V14.225C9.62502 14.6 9.32502 14.85 9.00002 14.85C8.88335 14.85 8.64169 14.85 8.37502 14.85V11.9333C8.64169 11.9333 8.88335 11.9333 9.00002 11.9333C9.32502 11.9333 9.62502 12.1833 9.62502 12.5583ZM12.5417 15.8917H11.5V10.8333H14.8334V11.875H12.5417V13.1H14V14.1417H12.5417V15.8917Z"
        fill={svgProps.fill}
      />
    </svg>
  );
};

PDFIcon.iconType = ICON_TYPES.PDF_ICON;
